import { postReferralsCje } from '@/api/post-referrals-cje'
import { whenEppoIsReady, useEppo } from '@/composables/eppo'
import { FEATURE_FLAGS } from '@/lib/consts'
import { useLogger } from '@booksy-com/vue-tools'

import { getCjEventIdFromSearch, normalizeCjEventId } from './index'

const logger = useLogger('cj-affiliate:persist')

export async function persistCjEvent (cjEvent: string): Promise<void> {
  const normalizedCjEvent = normalizeCjEventId(cjEvent)

  if (!normalizedCjEvent) {
    return
  }

  await postReferralsCje(normalizedCjEvent)
}

export async function tryPersistCjEvent (search?: string): Promise<void> {
  const searchValue = search ?? (typeof window !== 'undefined' ? window.location.search : '')
  const cjEvent = getCjEventIdFromSearch(searchValue)

  if (!cjEvent) {
    return
  }

  try {
    await persistCjEvent(cjEvent)
  } catch (error) {
    logger.warn('Failed to persist CJ event cookie', error)
  }
}

export function initCjAffiliateAttribution (): void {
  whenEppoIsReady.then(() => {
    if (!useEppo().ff(FEATURE_FLAGS.Feature_CjAffiliateAttribution)) {
      return
    }

    void tryPersistCjEvent()
  })
}
